module.exports = __webpack_public_path__ + "img/charity.661429dd.jpg";